"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4216],{

/***/ 40532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgBadgeCheckSolid(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 6,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.065 3.065 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.065 3.065 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
    fill: "currentColor"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgBadgeCheckSolid);

/***/ }),

/***/ 40577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _defs, _circle, _path, _path2, _circle2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgLogoOnboarding(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 607.6 96.77"
  }, props), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("style", null, ".logo-onboarding_svg__cls-1{fill:#171d26}"))), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    className: "logo-onboarding_svg__cls-1",
    cx: 73.34,
    cy: 22.8,
    r: 22.23
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#ee9ab2",
    d: "M0 .48h44.45v44.45H0z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#ffc550",
    d: "M73.34 54.42l11.6 20.54 11.6 20.53h-46.4l11.6-20.53 11.6-20.54z"
  })), _circle2 || (_circle2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 22.23,
    cy: 73.58,
    r: 22.23,
    fill: "#5263f3"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    className: "logo-onboarding_svg__cls-1",
    d: "M163.19 32.67v14.21a13.9 13.9 0 00-5.78-1.14c-8.93 0-15.46 7-15.46 18v31.8h-15.21V32.67h15.21V42c3.39-6.28 8.8-10.3 15.71-10.3a15.15 15.15 0 015.53.97zM226.61 66.86h-50c1.13 10 8.67 16.84 18.09 16.84a18.43 18.43 0 0016.34-9.3l12.82 5.15c-5 10.43-16 17.22-28.78 17.22-21 0-33.81-14.46-33.81-32.68s13.83-32.67 33.43-32.67c18.23 0 31.92 13.07 32.18 32.17zM177.98 55.8h32.32c-2.39-7.17-7.92-11.56-15.84-11.56a16.92 16.92 0 00-16.48 11.56zM228.87 64.09c0-18.72 15-32.67 33.93-32.67 13.7 0 25.38 7.29 30.54 19.73l-13.58 5.65a17.89 17.89 0 00-17-11.31c-10.94 0-18.73 7.79-18.73 18.6s7.79 18.6 18.73 18.6a17.87 17.87 0 0017-11.31L293.3 77c-5.16 12.44-16.84 19.73-30.54 19.73-18.94.04-33.89-13.91-33.89-32.64zM297.86 1.26h15.21v94.25h-15.21zM386.42 32.67v62.84h-15.2V88c-4.78 5.53-11.82 8.8-20.87 8.8-17 0-31-14.46-31-32.68s14.08-32.67 31-32.67c9.05 0 16.09 3.26 20.87 8.79v-7.57zm-14.7 31.42a18.6 18.6 0 10-18.6 18.6 18.48 18.48 0 0018.6-18.6zM395.3 9.05a9.045 9.045 0 1118.09 0 9.045 9.045 0 01-18.09 0zm1.38 23.62h15.2v62.84h-15.2zM512.24 55.67v39.84h-15.21V56.8a10.94 10.94 0 00-11.19-11.31c-6.66 0-11.05 5.28-11.05 11.82v38.2h-15.21V56.8a10.94 10.94 0 00-11.19-11.31c-6.78 0-11 5.28-11 11.82v38.2h-15.26V32.67h15.17v6.16a19.55 19.55 0 0115.08-7.41c7 0 13.57 3.77 17.84 9.8a22.1 22.1 0 0118.6-9.8c13.36 0 23.42 10.68 23.42 24.25zM583.3 32.67v62.84H573v-9.05c-5.41 6.41-13.58 10.31-23.63 10.31-16.84 0-31.42-14.58-31.42-32.68s14.58-32.67 31.42-32.67c10.05 0 18.22 3.89 23.63 10.3v-9zM573 64.09a22.37 22.37 0 10-22.37 22.37 22.26 22.26 0 0022.35-22.37zM593.53 7a7.035 7.035 0 1114.07 0 7.035 7.035 0 01-14.07 0zm1.88 25.63h10.31v62.88h-10.31z"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgLogoOnboarding);

/***/ }),

/***/ 54216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ CurrentUser; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(38396);
/* harmony import */ var _material_ui_core_Avatar__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(67265);
/* harmony import */ var _material_ui_core_Badge__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(59009);
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80343);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_icons_KeyboardArrowDownRounded__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(9722);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_UserNav__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27218);
/* harmony import */ var _context_UserContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59484);
/* harmony import */ var _utils_users__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96479);
/* harmony import */ var _Tooltip__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15695);



















var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            display: "flex",
            zIndex: theme.zIndex.appBar
        },
        smallButton: {
            padding: 3,
            paddingRight: 8,
            border: "1px solid #dedede"
        },
        currentUser: {
            width: "100%"
        },
        label: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, theme.typography.body2), {
            display: "flex",
            flexDirection: "column",
            fontWeight: theme.typography.fontWeightMedium,
            alignItems: "flex-start",
            "&.light": {
                color: theme.palette.common.white
            },
            "&.dark": {
                color: theme.palette.text.primary
            }
        }),
        username: {
            color: theme.palette.common.white,
            whiteSpace: "nowrap",
            "&.light": {
                color: theme.palette.common.white
            },
            "&.dark": {
                color: theme.palette.text.primary
            }
        },
        avatar: {
            height: 24,
            width: 24,
            "&$largeAvatar": {
                height: 32,
                width: 32
            }
        },
        smallUserName: {
            fontSize: 14
        },
        smallAvatar: {
            height: 24,
            width: 24
        },
        largeAvatar: {},
        downChevron: {
            marginLeft: -4,
            "&.light": {
                color: theme.palette.common.white
            },
            "&.dark": {
                color: theme.palette.text.primary
            }
        },
        menu: {
            margin: theme.spacing(5, 0, 1, 0)
        },
        menuPaper: {
            minWidth: "13em",
            color: theme.palette.getContrastText("#363740"),
            backgroundColor: "#363740",
            borderRadius: theme.shape.borderRadius * 1.5
        }
    };
}, {
    classNamePrefix: "CurrentUser"
});
var CurrentUser = function(param) {
    var className = param.className, _color = param.color, color = _color === void 0 ? "light" : _color, _isOnboarding = param.isOnboarding, isOnboarding = _isOnboarding === void 0 ? false : _isOnboarding, _variant = param.variant, variant = _variant === void 0 ? "account" : _variant, size = param.size;
    var classes = useStyles();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_context_UserContext__WEBPACK_IMPORTED_MODULE_3__/* .useUserContext */ .SE)(), 1), ref1 = ref[0], user = ref1.user, isAuthenticated = ref1.isAuthenticated;
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), open = ref2[0], setOpen = ref2[1];
    var anchorRef = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    // return focus to the button when we transitioned from !open -> open
    var prevOpen = react__WEBPACK_IMPORTED_MODULE_1__.useRef(open);
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [
        open
    ]);
    var monogram = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,_utils_users__WEBPACK_IMPORTED_MODULE_4__/* .getUserMonogram */ .Sk)(user);
    }, [
        user
    ]);
    var handleToggle = function() {
        setOpen(function(prevOpen) {
            return !prevOpen;
        });
    };
    var handleClose = function(event) {
        var ref;
        if ((ref = anchorRef.current) === null || ref === void 0 ? void 0 : ref.contains(event.target)) {
            return;
        }
        setOpen(false);
    };
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(classes.root, className),
        children: !!user && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            className: classes.currentUser,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Tooltip__WEBPACK_IMPORTED_MODULE_5__/* .Tooltip */ .u, {
                    title: user.email || "",
                    placement: "bottom",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        ref: anchorRef,
                        variant: "text",
                        size: "large",
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, classes.smallButton, size === "small")),
                        "aria-controls": open ? "menu-list-grow" : undefined,
                        "aria-haspopup": "true",
                        onClick: handleToggle,
                        startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Badge__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            badgeContent: 0,
                            color: "secondary",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Avatar__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(classes.avatar, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, classes.largeAvatar, size === "large"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, classes.smallAvatar, size === "small"), _obj)),
                                src: user.avatarUrl,
                                alt: user.email,
                                title: user.email,
                                children: monogram
                            })
                        }),
                        endIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_KeyboardArrowDownRounded__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(classes.downChevron, color)
                        }),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            className: classes.label,
                            children: function() {
                                switch(variant){
                                    case "account":
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(classes.label, color),
                                            children: "Account"
                                        });
                                    case "name":
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                            variant: "body1",
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(classes.username, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, classes.smallUserName, size === "small"), color),
                                            children: user.name
                                        });
                                }
                            }()
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                    className: classes.menu,
                    open: open,
                    classes: {
                        paper: classes.menuPaper
                    },
                    anchorEl: anchorRef.current,
                    role: undefined,
                    onClose: handleClose,
                    children: isAuthenticated && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UserNav__WEBPACK_IMPORTED_MODULE_2__/* .UserNav */ .T, {
                        isCollapsible: false,
                        showAvatar: false,
                        isOnboarding: isOnboarding,
                        onMenuClose: handleClose
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CurrentUser);


/***/ }),

/***/ 91491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ ReclaimLogo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80343);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17812);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _img_logo_onboarding_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40577);





var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(theme) {
    var _obj;
    return {
        root: (_obj = {
            display: "block",
            margin: theme.spacing(2, "auto", 3),
            textAlign: "center"
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, theme.breakpoints.up("sm"), {
            margin: theme.spacing(5, "auto")
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "&&:hover", {
            background: "transparent"
        }), _obj),
        btn: {
            cursor: "default",
            "&:hover": {
                background: "transparent"
            }
        },
        svg: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            height: "auto",
            maxWidth: 120,
            width: "100%"
        }, theme.breakpoints.up("sm"), {
            marginLeft: theme.spacing(-2),
            maxWidth: 220
        })
    };
});
var ReclaimLogo = function() {
    var classes = useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        className: classes.root,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            className: classes.btn,
            size: "medium",
            "aria-label": "reclaim.ai",
            disableRipple: true,
            disableFocusRipple: true,
            disableTouchRipple: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_img_logo_onboarding_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                className: classes.svg,
                preserveAspectRatio: "xMidYMid meet"
            })
        })
    });
};


/***/ }),

/***/ 27218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ UserNav; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(10253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(62822);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(50998);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(46869);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(59009);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(67265);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(95757);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(81860);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(66037);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(55517);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(52663);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(82285);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(59693);
/* harmony import */ var _material_ui_icons_ChevronRightRounded__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(28659);
/* harmony import */ var _material_ui_icons_ExpandMoreRounded__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(65941);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_onboarding_OnboardingBuffet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54542);
/* harmony import */ var _context_AppContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64574);
/* harmony import */ var _context_UserContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59484);
/* harmony import */ var _hooks_useOpenIntercom__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52998);
/* harmony import */ var _hooks_useOurRouter__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52581);
/* harmony import */ var _hooks_useSubscriptionLogic__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55004);
/* harmony import */ var _utils_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63429);
/* harmony import */ var _utils_users__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96479);
/* harmony import */ var _billing_EditionBadge__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64462);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34557);
/* harmony import */ var _Tooltip__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15695);




















var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function(theme) {
    return {
        listItem: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
            padding: theme.spacing(0.5, "22px", 1.5, 2),
            color: theme.palette.common.white,
            cursor: "pointer",
            whiteSpace: "nowrap",
            "&:hover": {
                backgroundColor: (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_15__/* .alpha */ .Fq)(theme.palette.common.white, 0.075)
            }
        }, theme.breakpoints.up("sm"), {
            paddingBottom: theme.spacing(1)
        }),
        nestedListItem: {
            padding: theme.spacing(1, 2)
        },
        avatarListItem: {
            paddingLeft: theme.spacing(8)
        },
        label: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            margin: 0,
            whiteSpace: "nowrap"
        },
        navToggle: {
            opacity: 1,
            right: 8,
            transition: theme.transitions.create([
                "opacity"
            ], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
                delay: 25
            })
        },
        navToggleClosed: {
            opacity: 0,
            transition: theme.transitions.create([
                "opacity"
            ], {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.shortest,
                delay: 0
            })
        },
        avatar: {
            height: 32,
            marginRight: theme.spacing(2),
            width: 32
        },
        navIcon: {
            minWidth: 0,
            justifyContent: "center",
            color: theme.palette.common.white,
            opacity: 0.8
        },
        userName: {
            lineHeight: 1,
            marginTop: theme.spacing(0.25),
            maxWidth: 160
        },
        listItemText: {
            fontWeight: theme.typography.fontWeightMedium,
            margin: 0
        },
        divider: {
            backgroundColor: "rgba(255,255,255,.1)"
        }
    };
}, {
    classNamePrefix: "UserNav"
});
var UserNav = function(param) {
    var _isCollapsible = param.isCollapsible, isCollapsible = _isCollapsible === void 0 ? true : _isCollapsible, _showAvatar = param.showAvatar, showAvatar = _showAvatar === void 0 ? true : _showAvatar, _isOnboarding = param.isOnboarding, isOnboarding = _isOnboarding === void 0 ? false : _isOnboarding, onMenuClose = param.onMenuClose;
    var classes = useStyles();
    var ref = (0,_context_AppContext__WEBPACK_IMPORTED_MODULE_3__/* .useAppContext */ .bp)(), nav = ref.state.nav;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_context_UserContext__WEBPACK_IMPORTED_MODULE_4__/* .useUserContext */ .SE)(), 2), user = ref1[0].user, actions = ref1[1];
    var userCurrentEdition = (0,_hooks_useSubscriptionLogic__WEBPACK_IMPORTED_MODULE_7__/* .useSubscriptionLogic */ .Y)().userCurrentEdition;
    var router = (0,_hooks_useOurRouter__WEBPACK_IMPORTED_MODULE_6__/* .useOurRouter */ .ED)();
    var monogram = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,_utils_users__WEBPACK_IMPORTED_MODULE_9__/* .getUserMonogram */ .Sk)(user);
    }, [
        user
    ]);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(function() {
        var ref;
        return router === null || router === void 0 ? void 0 : (ref = router.pathname) === null || ref === void 0 ? void 0 : ref.startsWith((0,_utils_router__WEBPACK_IMPORTED_MODULE_8__/* .getBillingUrl */ .uN)());
    }), open = ref2[0], setOpen = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), gettingStartedOpen = ref3[0], setGettingStartedOpen = ref3[1];
    var ref4 = (0,_hooks_useOpenIntercom__WEBPACK_IMPORTED_MODULE_5__/* .useOpenIntercom */ .b)(), openIntercom = ref4.openIntercom, _analytics = ref4.analytics, segment = _analytics.state.segment;
    var handleHelpClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(event) {
        onMenuClose === null || onMenuClose === void 0 ? void 0 : onMenuClose(event);
        openIntercom();
    }, [
        openIntercom,
        onMenuClose
    ]);
    var handleCloseGettingStarted = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return setGettingStartedOpen(false);
    }, []);
    var handleLogout = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return actions === null || actions === void 0 ? void 0 : actions.logout();
    }, [
        actions
    ]);
    var handleMenuExpand = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        e.preventDefault();
        e.stopPropagation();
        setOpen(!open);
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
        component: "nav",
        disablePadding: true,
        children: [
            !!user && (!isOnboarding ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        className: classes.listItem,
                        component: _Link__WEBPACK_IMPORTED_MODULE_11__/* .Link */ .r,
                        href: "/users/self",
                        underline: "none",
                        children: [
                            showAvatar && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                className: classes.navIcon,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                    badgeContent: 0,
                                    color: "secondary",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(classes.avatar, showAvatar),
                                        src: user.avatarUrl,
                                        alt: user.email,
                                        title: user.email,
                                        children: monogram
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Tooltip__WEBPACK_IMPORTED_MODULE_12__/* .Tooltip */ .u, {
                                title: user.email || "",
                                placement: "right",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                    primary: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            userCurrentEdition && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_billing_EditionBadge__WEBPACK_IMPORTED_MODULE_10__/* .EditionBadge */ .M, {
                                                edition: userCurrentEdition,
                                                size: "small"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                                                className: classes.userName,
                                                noWrap: true,
                                                children: user.name
                                            })
                                        ]
                                    }),
                                    className: classes.label
                                })
                            }),
                            isCollapsible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(classes.navToggle, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, classes.navToggleClosed, !nav.open)),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                    className: classes.navIcon,
                                    onClick: handleMenuExpand,
                                    children: !open ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_ChevronRightRounded__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                                        fontSize: "small",
                                        color: "inherit"
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_ExpandMoreRounded__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                        fontSize: "small",
                                        color: "inherit"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
                        in: open && nav.open || !isCollapsible,
                        timeout: "auto",
                        unmountOnExit: true,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_11__/* .Link */ .r, {
                                href: (0,_utils_router__WEBPACK_IMPORTED_MODULE_8__/* .getBillingUrl */ .uN)(),
                                underline: "none",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(classes.listItem, classes.nestedListItem, showAvatar && classes.avatarListItem),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                        className: classes.listItemText,
                                        primary: "Billing & Team",
                                        disableTypography: true
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_11__/* .Link */ .r, {
                                href: "/settings/accounts",
                                underline: "none",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(classes.listItem, classes.nestedListItem, showAvatar && classes.avatarListItem),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                        className: classes.listItemText,
                                        primary: "Calendars",
                                        disableTypography: true
                                    })
                                })
                            }),
                            !isCollapsible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                                className: classes.divider
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(classes.listItem, classes.nestedListItem, showAvatar && classes.avatarListItem),
                                onClick: function(e) {
                                    setGettingStartedOpen(true);
                                    segment === null || segment === void 0 ? void 0 : segment.track("Getting Started Clicked", {
                                        category: "Nav"
                                    });
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                    className: classes.listItemText,
                                    primary: "Get Started",
                                    disableTypography: true
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_11__/* .Link */ .r, {
                                href: "https://reclaim.ai/webinars-demos",
                                underline: "none",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(classes.listItem, classes.nestedListItem, showAvatar && classes.avatarListItem),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                        className: classes.listItemText,
                                        primary: "Webinars & Demos",
                                        disableTypography: true
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_11__/* .Link */ .r, {
                                href: "https://updates.reclaim.ai",
                                underline: "none",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(classes.listItem, classes.nestedListItem, showAvatar && classes.avatarListItem),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                        className: classes.listItemText,
                                        primary: "Product Updates",
                                        disableTypography: true
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                button: true,
                                "data-intercom-target": "nav-help",
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(classes.listItem, classes.nestedListItem, showAvatar && classes.avatarListItem),
                                onClick: handleHelpClick,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                    primary: "Help",
                                    className: classes.listItemText,
                                    disableTypography: true
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                button: true,
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(classes.listItem, classes.nestedListItem, showAvatar && classes.avatarListItem),
                                onClick: handleLogout,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                    className: classes.listItemText,
                                    primary: "Log Out",
                                    disableTypography: true
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                button: true,
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(classes.listItem, classes.nestedListItem, showAvatar && classes.avatarListItem),
                onClick: handleLogout,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                    className: classes.listItemText,
                    primary: "Log Out",
                    disableTypography: true
                })
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                fullScreen: true,
                open: gettingStartedOpen,
                onClose: handleCloseGettingStarted,
                TransitionComponent: _material_ui_core__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z,
                TransitionProps: {
                    timeout: 250,
                    direction: "up"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_onboarding_OnboardingBuffet__WEBPACK_IMPORTED_MODULE_2__/* .OnboardingBuffet */ .Q, {
                    onClose: handleCloseGettingStarted
                })
            })
        ]
    });
};


/***/ }),

/***/ 64462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ EditionBadge; }
/* harmony export */ });
/* unused harmony export EditionBadgeContext */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41120);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _AppTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60146);
/* harmony import */ var _hooks_useSubscriptionLogic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55004);
/* harmony import */ var _reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50084);
/* harmony import */ var _EditionBadgeBase__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55187);












var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(theme) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, _AppTheme__WEBPACK_IMPORTED_MODULE_2__/* .OPACITY_PULSE.keyframes */ .zd.keyframes), {
        root: {},
        loading: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, _AppTheme__WEBPACK_IMPORTED_MODULE_2__/* .OPACITY_PULSE.elementStyles */ .zd.elementStyles), {
            width: 50
        })
    });
}, {
    classNamePrefix: "EditionBadge"
});
var EditionBadgeContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    tooltipOpen: false,
    setTooltipOpen: function() {
        return void 0;
    }
});
var EditionBadge = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var edition = _param.edition, className = _param.className, EditionBadgeBaseClasses = _param.EditionBadgeBaseClasses, showIfTrial = _param.showIfTrial, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_param, [
        "edition",
        "className",
        "EditionBadgeBaseClasses",
        "showIfTrial"
    ]);
    var classes = useStyles();
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(EditionBadgeContext), tooltipOpen = _$ref.tooltipOpen, setTooltipOpen = _$ref.setTooltipOpen;
    var userIsOnTrial = (0,_hooks_useSubscriptionLogic__WEBPACK_IMPORTED_MODULE_3__/* .useSubscriptionLogic */ .Y)().userIsOnTrial;
    var handleTouchEndCapture = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        if (!tooltipOpen) {
            // preventDefault on touchEnd blocks click event
            e.preventDefault();
            e.stopPropagation();
            setTooltipOpen(true);
        } else setTooltipOpen(false);
    }, [
        setTooltipOpen,
        tooltipOpen
    ]);
    var loading = !edition;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_EditionBadgeBase__WEBPACK_IMPORTED_MODULE_5__/* .EditionBadgeBase */ .i, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        onTouchEndCapture: handleTouchEndCapture,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(classes.root, className, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, classes.loading, loading)),
        paid: edition !== "LITE" && edition !== "ASSISTANT",
        classes: EditionBadgeBaseClasses,
        ref: ref
    }, rest), {
        children: edition ? function() {
            var _edition = _reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_4__/* .EDITION_META */ .JZ[edition], label = _edition.label, isTrial = _edition.isTrial;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    label,
                    showIfTrial && (isTrial || userIsOnTrial) ? " trial" : ""
                ]
            });
        }() : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: "\xa0"
        })
    }));
});
EditionBadge.displayName = "EditionBadge";


/***/ }),

/***/ 55187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ EditionBadgeBase; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59693);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);








var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    return {
        root: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, theme.typography.caption), {
            backgroundColor: (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* .lighten */ .$n)(theme.colors.grey, 0.6),
            borderRadius: 4,
            color: theme.palette.text.primary,
            display: "inline-block",
            fontWeight: theme.typography.fontWeightMedium,
            lineHeight: "16px",
            padding: theme.spacing(0, 0.5),
            textTransform: "uppercase",
            pointerEvents: "auto",
            cursor: "default"
        }),
        paid: {
            backgroundColor: theme.colors.logo.corn
        },
        medium: {},
        small: {},
        slim: {}
    };
}, {
    classNamePrefix: "EditionBadgeBase"
});
var EditionBadgeBase = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var className = _param.className, extClasses = _param.classes, _size = _param.size, size = _size === void 0 ? "medium" : _size, paid = _param.paid, children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "className",
        "classes",
        "size",
        "paid",
        "children"
    ]);
    var classes = useStyles({
        classes: extClasses
    });
    var _obj;
    /********************/ /*       JSX        */ /********************/ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.root, className, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, classes.paid, paid), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, classes.medium, size === "medium"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, classes.small, size === "small"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, classes.slim, size === "slim"), _obj)),
        ref: ref
    }, rest), {
        children: children
    }));
});
EditionBadgeBase.displayName = "EditionBadgeBase";


/***/ }),

/***/ 95569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ DoneStepBuffet; }
});

// UNUSED EXPORTS: OnboardingType

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 12 modules
var Box = __webpack_require__(80343);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useOurRouter.ts
var useOurRouter = __webpack_require__(52581);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(34557);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/KeyboardArrowRight.js
var KeyboardArrowRight = __webpack_require__(56251);
// EXTERNAL MODULE: ./src/img/badge-check-solid.svg
var badge_check_solid = __webpack_require__(40532);
;// CONCATENATED MODULE: ./src/components/onboarding/MoreOnboardingsGrid.tsx







var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {
            width: "100%",
            maxWidth: 780
        },
        item: {
            alignItems: "center",
            width: 220,
            display: "flex",
            flexDirection: "column",
            justifyItems: "center",
            textAlign: "center",
            margin: theme.spacing(2.5),
            backgroundColor: "#E4E6E8",
            borderRadius: theme.shape.borderRadius * 3,
            boxShadow: "none",
            padding: theme.spacing(2),
            position: "relative",
            color: theme.colors.black,
            transform: "none",
            "&:hover": {
                cursor: "pointer",
                backgroundColor: theme.colors.primary,
                boxShadow: "0 7px 33px -8px #5267EA",
                color: theme.colors.white,
                transform: "translateY(-3px)",
                "& $linkArrow": {
                    color: theme.palette.secondary.main,
                    margin: 0,
                    opacity: 1
                },
                "& $imageContainer": {
                    transform: "scale(1.05)"
                },
                "& $viewedIcon": {
                    color: theme.palette.common.white
                }
            },
            transition: theme.transitions.create([
                "background",
                "boxShadow",
                "color",
                "transform"
            ], {
                duration: theme.transitions.duration.shortest
            })
        },
        imageContainer: {
            maxHeight: 220,
            position: "relative",
            transform: "none",
            width: 240,
            transition: theme.transitions.create([
                "transform"
            ], {
                duration: theme.transitions.duration.shortest
            })
        },
        words: {
            height: "30%"
        },
        title: {
            display: "flex",
            justifyContent: "center"
        },
        linkArrow: {
            color: theme.colors.black,
            marginRight: -24,
            opacity: 0,
            position: "relative",
            transition: theme.transitions.create([
                "color",
                "opacity",
                "margin"
            ], {
                duration: theme.transitions.duration.shortest
            })
        },
        description: {
            padding: theme.spacing(0, 1)
        },
        viewedIcon: {
            color: theme.palette.common.black,
            height: 20,
            opacity: 0.2,
            position: "absolute",
            right: theme.spacing(1),
            top: theme.spacing(1),
            width: 20,
            zIndex: 1
        }
    };
});
var MoreOnboardingsGrid = function(param) {
    var items = param.items, onItemClick = param.onItemClick;
    var classes = useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
        className: classes.root,
        container: true,
        justifyContent: "center",
        alignItems: "stretch",
        children: !!(items === null || items === void 0 ? void 0 : items.length) && items.map(function(item) {
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                item: true,
                className: classes.item,
                href: item.href,
                onClick: function() {
                    return onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(item);
                },
                component: Link/* Link */.r,
                underline: "none",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: classes.imageContainer,
                        children: item.image
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: classes.words,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                className: classes.title,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h4",
                                        children: item.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {
                                        className: classes.linkArrow
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: classes.description,
                                variant: "body1",
                                children: item.description
                            })
                        ]
                    }),
                    !!item.complete && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge_check_solid/* default */.Z, {
                        className: classes.viewedIcon
                    })
                ]
            }, item.id);
        })
    });
};

;// CONCATENATED MODULE: ./src/components/onboarding/DoneStepBuffet.tsx










var DoneStepBuffet_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj;
    return {
        body: {
            alignItems: "center",
            display: "flex"
        },
        moreLinks: (_obj = {
            padding: theme.spacing(2, 0, 16),
            textAlign: "center"
        }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("sm"), {
            padding: theme.spacing(2, 0, 4)
        }), (0,_define_property/* default */.Z)(_obj, "& a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.typography.subtitle1), {
            display: "inline-block",
            fontWeight: theme.typography.fontWeightMedium,
            padding: theme.spacing(0.5, 1)
        })), (0,_define_property/* default */.Z)(_obj, "& a:hover", {
            backgroundColor: theme.palette.grey[100],
            borderRadius: 8
        }), _obj),
        subheading: {
            marginBottom: theme.spacing(1)
        }
    };
});
var OnboardingType;
(function(OnboardingType) {
    OnboardingType["BufferTime"] = "BufferTime";
    OnboardingType["OneOnOnes"] = "OneOnOnes";
})(OnboardingType || (OnboardingType = {}));
var DoneStepBuffet = function(param) {
    var onboardings = param.onboardings, hideExploreOnOwnLinks = param.hideExploreOnOwnLinks;
    var classes = DoneStepBuffet_useStyles();
    var router = (0,useOurRouter/* useOurRouter */.ED)();
    var items = (0,react.useMemo)(function() {
        return [
            {
                id: "one-on-ones",
                title: "Smart 1:1s",
                description: "Auto-schedule your one-on-ones",
                href: "/one-on-ones?action=onboard",
                complete: !!(onboardings === null || onboardings === void 0 ? void 0 : onboardings.smartOneOnOnes),
                image: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    layout: "intrinsic",
                    width: 500,
                    height: 500,
                    src: "/img/onboarding/user/welcome-oneonones.svg",
                    alt: "welcome one-on-ones"
                })
            },
            {
                id: "buffer",
                title: "Buffer Time",
                description: "Block time between meetings",
                href: "/onboarding/buffer-time",
                complete: !!(onboardings === null || onboardings === void 0 ? void 0 : onboardings.bufferTime),
                image: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    layout: "intrinsic",
                    width: 500,
                    height: 500,
                    src: "/img/onboarding/user/welcome-buffer.svg",
                    alt: "buffer time"
                })
            },
            {
                id: "add-on",
                title: "Google Add-on",
                description: "Reclaim right from Google Calendar",
                href: "https://workspace.google.com/marketplace/app/reclaimai/950518663892",
                complete: !!(onboardings === null || onboardings === void 0 ? void 0 : onboardings.googleAddOn),
                image: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    layout: "intrinsic",
                    width: 500,
                    height: 500,
                    src: "/img/onboarding/user/addon.svg",
                    alt: "add-on graphic"
                })
            }, 
        ];
    }, [
        onboardings === null || onboardings === void 0 ? void 0 : onboardings.bufferTime,
        onboardings === null || onboardings === void 0 ? void 0 : onboardings.googleAddOn,
        onboardings === null || onboardings === void 0 ? void 0 : onboardings.smartOneOnOnes
    ]);
    var handleItemClick = (0,react.useCallback)(function(item) {
        if (item.href && item.id !== "add-on") {
            void router.push(item.href);
        }
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: classes.body,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreOnboardingsGrid, {
                    items: items,
                    onItemClick: handleItemClick
                })
            }),
            !hideExploreOnOwnLinks && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: classes.moreLinks,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: classes.subheading,
                        variant: "h5",
                        children: "Or explore on your own:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        underline: "none",
                        href: "/habits",
                        children: "Habits"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        underline: "none",
                        href: "/tasks",
                        children: "Tasks"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        underline: "none",
                        href: "/sync",
                        children: "Calendar Sync"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        underline: "none",
                        href: "/settings/hours",
                        children: "Scheduling Hours"
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 54542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ OnboardingBuffet; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80343);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_icons_CloseRounded__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(79138);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context_UserContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59484);
/* harmony import */ var _ReclaimLogo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91491);
/* harmony import */ var _DoneStepBuffet__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95569);
/* harmony import */ var _OnboardingTitle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7821);











var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: theme.palette.common.white
        },
        closeIcon: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            position: "absolute",
            zIndex: theme.zIndex.modal + 1,
            right: theme.spacing(2),
            top: theme.spacing(2)
        }, theme.breakpoints.up("md"), {
            right: theme.spacing(3),
            top: theme.spacing(3)
        })
    };
});
var OnboardingBuffet = function(param) {
    var onClose = param.onClose;
    var classes = useStyles();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_context_UserContext__WEBPACK_IMPORTED_MODULE_2__/* .useUserContext */ .SE)(), 1), user = ref[0].user;
    var onboardings = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return user === null || user === void 0 ? void 0 : user.features.onboard;
    }, [
        user
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        className: classes.root,
        children: [
            !!onClose && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                onClick: onClose,
                className: classes.closeIcon,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_CloseRounded__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ReclaimLogo__WEBPACK_IMPORTED_MODULE_3__/* .ReclaimLogo */ .k, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OnboardingTitle__WEBPACK_IMPORTED_MODULE_5__/* .OnboardingTitle */ .k, {
                title: "Get started with Reclaim",
                subtitle: "Set up our full suite of tools to make your work-life more efficient"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DoneStepBuffet__WEBPACK_IMPORTED_MODULE_4__/* .DoneStepBuffet */ .s, {
                onboardings: onboardings
            })
        ]
    });
};


/***/ }),

/***/ 7821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ OnboardingTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80343);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41120);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            margin: theme.spacing(0, "auto", 3),
            maxWidth: 640,
            padding: theme.spacing(0, 2),
            textAlign: "center"
        },
        subtitle: {
            margin: theme.spacing(1, 3)
        }
    };
});
var OnboardingTitle = function(param) {
    var className = param.className, extClasses = param.classes, title = param.title, subtitle = param.subtitle;
    var classes = useStyles({
        classes: extClasses
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                component: "h1",
                variant: "h3",
                children: title
            }),
            !!subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                variant: "subtitle1",
                className: classes.subtitle,
                children: subtitle
            })
        ]
    });
};


/***/ }),

/***/ 8846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ SUPPORT_EMAIL; }
/* harmony export */ });
var SUPPORT_EMAIL = "support@reclaim.ai";


/***/ }),

/***/ 52998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useOpenIntercom; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34557);
/* harmony import */ var _consts_emails__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8846);
/* harmony import */ var _context_AnalyticsContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89495);
/* harmony import */ var _useNotifications__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55973);






var useOpenIntercom = function(defaultMessage) {
    var ref;
    var analytics = (0,_context_AnalyticsContext__WEBPACK_IMPORTED_MODULE_3__/* .useAnalyticsContext */ .Os)();
    var hasIntercom = !!((ref = analytics.state.intercom) === null || ref === void 0 ? void 0 : ref.booted);
    var sendNotification = (0,_useNotifications__WEBPACK_IMPORTED_MODULE_4__/* .useNotifications */ .z)().sendNotification;
    var openIntercom = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _state, ref;
        if (!hasIntercom) sendNotification({
            message: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    "Couldn't load Intercom. Try sending us an email at",
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Link__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .r, {
                        href: "mailto:".concat(_consts_emails__WEBPACK_IMPORTED_MODULE_5__/* .SUPPORT_EMAIL */ .X),
                        children: _consts_emails__WEBPACK_IMPORTED_MODULE_5__/* .SUPPORT_EMAIL */ .X
                    }),
                    ". Want to know more? Check out our",
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Link__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .r, {
                        href: "https://help.reclaim.ai/en/articles/6338330",
                        children: "help docs"
                    }),
                    "."
                ]
            }),
            type: "warning"
        });
        else (ref = (_state = analytics.state).intercom) === null || ref === void 0 ? void 0 : ref.call(_state, "show");
    }, [
        analytics.state,
        hasIntercom,
        sendNotification
    ]);
    var openIntercomCallback = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return openIntercom();
    }, [
        openIntercom
    ]);
    return {
        openIntercom: openIntercom,
        openIntercomCallback: openIntercomCallback,
        analytics: analytics,
        hasIntercom: hasIntercom
    };
};


/***/ }),

/***/ 55004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useSubscriptionLogic; }
/* harmony export */ });
/* harmony import */ var _reclaim_api_team_Team__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72897);
/* harmony import */ var _reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50084);
/* harmony import */ var _reclaim_api_team_Team_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13811);
/* harmony import */ var _atoms_useTeam__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10352);
/* harmony import */ var _useUsageData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38539);





var useSubscriptionLogic = function() {
    var usageData = (0,_useUsageData__WEBPACK_IMPORTED_MODULE_4__/* .useUsageData */ .L)().usageData;
    var ref = (0,_atoms_useTeam__WEBPACK_IMPORTED_MODULE_3__/* .useTeamState */ .O)(), team = ref.team, userMembership = ref.userMembership;
    /**
   * Member subscription
   */ var userCurrentEdition = usageData === null || usageData === void 0 ? void 0 : usageData.currentEdition;
    var userTerminalEdition = usageData === null || usageData === void 0 ? void 0 : usageData.terminalEdition;
    var userUsageEdition = usageData === null || usageData === void 0 ? void 0 : usageData.usageEdition;
    var userIsAdmin = (userMembership === null || userMembership === void 0 ? void 0 : userMembership.membershipRole) === _reclaim_api_team_Team__WEBPACK_IMPORTED_MODULE_0__/* .MembershipRole.Admin */ .nJ.Admin;
    var userIsOnRewards = !!userCurrentEdition && !!_reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_1__/* .EDITION_META */ .JZ[userCurrentEdition].isReward;
    var userIsOnTrial = !!(userMembership === null || userMembership === void 0 ? void 0 : userMembership.trial) && !userIsOnRewards;
    var userDaysLeftInTrial = userMembership === null || userMembership === void 0 ? void 0 : userMembership.daysLeftInTrial;
    var userTrialEnd = userMembership === null || userMembership === void 0 ? void 0 : userMembership.trialEnd;
    var userIsOnPaidSeat = !!(userMembership === null || userMembership === void 0 ? void 0 : userMembership.paidSeat);
    var userCanRedeemRewards = !!(team === null || team === void 0 ? void 0 : team.members.length) && team.members.length === 1;
    /**
   * Team subscription
   */ var subscriptionFrequency = team === null || team === void 0 ? void 0 : team.pricingSummary.subscriptionFrequency;
    var hasActiveSubscription = !!(team === null || team === void 0 ? void 0 : team.hasSubId);
    var teamHasAutoRenew = !!(team === null || team === void 0 ? void 0 : team.pricingSummary.autoRenew);
    var teamPlanIsCancelled = !!team && !!userCurrentEdition && !teamHasAutoRenew && !_reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_1__/* .EDITION_META */ .JZ[userCurrentEdition].isNonPaid && !!team.pricingSummary.subscriptionEnd ? {
        check: true,
        date: new Date(team.pricingSummary.subscriptionEnd)
    } : {
        check: false
    };
    /**
   * Legacy plan support
   */ var userCanInvite = (0,_reclaim_api_team_Team_utils__WEBPACK_IMPORTED_MODULE_2__/* .canInvite */ .AE)(userMembership === null || userMembership === void 0 ? void 0 : userMembership.membershipRole, team === null || team === void 0 ? void 0 : team.userInviteLevel);
    var userCanChangeSettings = (0,_reclaim_api_team_Team_utils__WEBPACK_IMPORTED_MODULE_2__/* .canChangeSettings */ .M9)(userMembership === null || userMembership === void 0 ? void 0 : userMembership.membershipRole);
    var userCanSetInviteLevels = !!team && !team.pricingSummary.homogeneous && userIsAdmin && team.userInviteLevel !== "NONE";
    var pendingClawback = (userMembership === null || userMembership === void 0 ? void 0 : userMembership.edition) === "ASSISTANT" && (usageData === null || usageData === void 0 ? void 0 : usageData.currentEdition) !== "ASSISTANT";
    // TODO (RAI-7793)
    if (!(team === null || team === void 0 ? void 0 : team.newPricing) && userIsOnTrial) {
        userIsOnTrial = userIsOnTrial && (userMembership === null || userMembership === void 0 ? void 0 : userMembership.editionAfterTrial) !== "TEAM";
    }
    return {
        userCurrentEdition: userCurrentEdition,
        userTerminalEdition: userTerminalEdition,
        userUsageEdition: userUsageEdition,
        userIsAdmin: userIsAdmin,
        userIsOnTrial: userIsOnTrial,
        userDaysLeftInTrial: userDaysLeftInTrial,
        userTrialEnd: userTrialEnd,
        userIsOnPaidSeat: userIsOnPaidSeat,
        userIsOnRewards: userIsOnRewards,
        userCanRedeemRewards: userCanRedeemRewards,
        subscriptionFrequency: subscriptionFrequency,
        hasActiveSubscription: hasActiveSubscription,
        userCanInvite: userCanInvite,
        userCanChangeSettings: userCanChangeSettings,
        userCanSetInviteLevels: userCanSetInviteLevels,
        pendingClawback: pendingClawback,
        teamHasAutoRenew: teamHasAutoRenew,
        teamPlanIsCancelled: teamPlanIsCancelled
    };
};


/***/ })

}]);